import React from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AuthContext from "./contexts/auth";

import ScrollRestoration from "./ScrollRestoration";

// Pages
import Home from "./pages/Home";
import PastProjects from "./pages/PastProjects";
import Tools from "./pages/Tools";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Settings from "./pages/Settings";
import Static from "./pages/Static";
import NotLogged from "./pages/401";
import NotFound from "./pages/404";
import ForgottenPassword from "./pages/forgottenPassword";
/// Designers
import Designers from "./pages/Designers";
import Designer from "./pages/Designer";
import EditWork from "./pages/EditWork";
import WorkWithDesigner from "./pages/WorkWithDesigner";
// Entrepreneurs
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import EditMission from "./pages/EditMission";
import WorkWithEntrepreneur from "./pages/WorkWithEntrepreneur";

function AppRouter() {
  const { authState } = React.useContext(AuthContext);

  // Define conditional component who need Auth
  const ProjectRoute = authState ? Project : NotLogged;
  const DesignerRoute = authState ? Designer : NotLogged;

  return (
    <div>
      <Router>
        <ScrollRestoration />
        <Switch>
          {/* Common */}
          <Route path="/" exact component={Home} />
          <Route path="/settings" exact component={Settings} />
          <Route path="/login" exact component={Login} />
          <Route path="/signup" exact component={SignUp} />
          <Route
            path="/forgottenpassword"
            exact
            component={ForgottenPassword}
          />

          {/* Designer */}
          <Route path="/designers" exact component={Designers} />
          <Route path="/designer/workwith" exact component={WorkWithDesigner} />
          <Route path="/designer/editwork" exact component={EditWork} />
          <Route
            path={["/designers/:slug", "/designer/:slug"]}
            exact
            component={DesignerRoute}
          />

          {/* Entrepreneur */}
          <Route path="/jobs" exact component={Projects} />
          <Route
            path="/project/workwith"
            exact
            component={WorkWithEntrepreneur}
          />
          <Route path="/project/editmission" exact component={EditMission} />
          <Route
            path={["/projects/:slug", "/project/:slug", "/contractor/:slug"]}
            exact
            component={ProjectRoute}
          />

          {/* Static pages */}
          <Route path="/showcase" exact component={PastProjects} />
          <Route path="/tools" exact component={Tools} />
          <Route path="/:slug" exact component={Static} />

          <Route component={NotFound} />
        </Switch>
      </Router>
    </div>
  );
}
export default AppRouter;
